import React from 'react';

import { LogoWithFallback } from '../logo-with-fallback';
import unknownIcon from './unknown-marketplace-icon.svg';
import unknownLogo from './unknown-marketplace-logo.svg';

/**
 * @typedef {object} MarketplaceDisplayInformation
 * @property {string} [logoUrl] - URL for the marketplace logo image
 * @property {string} [iconUrl] - URL for the marketplace icon image
 */

/**
 * @typedef {object} MarketplaceLogoProps
 * @property {MarketplaceDisplayInformation} [displayInformation] - Object containing URLs for marketplace logos
 * @property {'icon'|'alternateIcon'|'logo'} type - The type of logo to display
 */

const emptyDisplayInformation = {};

/**
 * Marketplace-specific logo component with default unknown marketplace fallbacks
 * @param {MarketplaceLogoProps & React.ImgHTMLAttributes<HTMLImageElement>} props
 * @returns {React.JSX.Element}
 */
export const MarketplaceLogo = ({ displayInformation = emptyDisplayInformation, type, ...rest }) => {
  return (
    <LogoWithFallback displayInformation={displayInformation} iconFallback={unknownIcon} logoFallback={unknownLogo} type={type} {...rest} />
  );
};
